export default __webpack_public_path__ + "static/media/plus_accordion.7a84852a.svg";